import { useState, useEffect } from 'react';
import { isMobileLayout } from 'utils';

export function useMobileLayout(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => isMobileLayout());

  useEffect(() => {
    function windowResized() {
      setIsMobile(isMobileLayout());
    }
    window.addEventListener('resize', windowResized);
    return () => {
      window.removeEventListener('resize', windowResized);
    };
  });

  return isMobile;
}



// WEBPACK FOOTER //
// ./src/hooks/useMobileLayout.ts